module.exports = __webpack_public_path__ + "static/case-study-6d42f660df7fb91a2a2eee89d133375a.png";